// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Gi-z","heading":"Hi-z","items":"Ii-z","featureCss":"Ji-z","disabled":"Ki-z","imgCss":"Li-z"};